type EnvShape = {
  VITE_API_URL?: string;
};

type RuntimeEnv = typeof globalThis & {
  __env?: EnvShape;
};

const runtimeEnv = globalThis as RuntimeEnv;

const resolvedApiUrl = import.meta.env.PROD
  ? runtimeEnv.__env?.VITE_API_URL
  : import.meta.env.VITE_API_URL;

if (!resolvedApiUrl && import.meta.env.PROD) {
  throw new Error('VITE_API_URL is not defined.');
}

export const API_URL: string = resolvedApiUrl ?? '';
